import { render, staticRenderFns } from "./InviteStudentSidebar.vue?vue&type=template&id=67d819d3&scoped=true&"
import script from "./InviteStudentSidebar.vue?vue&type=script&lang=js&"
export * from "./InviteStudentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InviteStudentSidebar.vue?vue&type=style&index=0&id=67d819d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d819d3",
  null
  
)

export default component.exports